import { render, staticRenderFns } from "./xueersi.vue?vue&type=template&id=1cd057e3&scoped=true"
import script from "./xueersi.vue?vue&type=script&lang=ts"
export * from "./xueersi.vue?vue&type=script&lang=ts"
import style0 from "./xueersi.vue?vue&type=style&index=0&id=1cd057e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd057e3",
  null
  
)

export default component.exports